<div class="p-4">
	<svg
		width="200"
		height="200"
		viewBox="0 0 200 200"
		role="img"
		aria-labelledby="title desc"
		xmlns="http://www.w3.org/2000/svg">
		<title id="title">Loading</title>
		<desc id="desc">MedInThePocket ECG animation.</desc>

		<defs>
			<!-- Colors: tweak these three to match your brand -->
			<linearGradient
				id="ecgGrad"
				x1="0%"
				y1="0%"
				x2="100%"
				y2="0%">
				<stop
					offset="0%"
					stop-color="#14b8a6" />
				<stop
					offset="50%"
					stop-color="#0ea5e9" />
				<stop
					offset="100%"
					stop-color="#22c55e" />
				<animateTransform
					attributeName="gradientTransform"
					type="rotate"
					from="0 0.5 0.5"
					to="360 0.5 0.5"
					dur="8s"
					repeatCount="indefinite" />
			</linearGradient>

			<radialGradient
				id="ringGlow"
				cx="50%"
				cy="50%"
				r="50%">
				<stop
					offset="60%"
					stop-color="#0ea5e9"
					stop-opacity="0.15" />
				<stop
					offset="100%"
					stop-color="#0ea5e9"
					stop-opacity="0" />
			</radialGradient>

			<filter id="softGlow">
				<feGaussianBlur
					stdDeviation="3"
					result="blur" />
				<feMerge>
					<feMergeNode in="blur" />
					<feMergeNode in="SourceGraphic" />
				</feMerge>
			</filter>

			<!-- Circular path for the orbiting pill -->
			<path
				id="orbit"
				d="M100,20 a80,80 0 1,1 0,160 a80,80 0 1,1 0,-160"
				fill="none" />
		</defs>

		<style>
			/* Reduce motion respect */
			@media (prefers-reduced-motion: reduce) {
				#ecg,
				#pill,
				#cross {
					animation: none !important;
				}
				#dashRing * {
					animation-duration: 0s !important;
				}
			}

			/* ECG scrolling line — offset must be a multiple of dasharray cycle (80+300=380) to loop seamlessly */
			@keyframes ecgFlow {
				to {
					stroke-dashoffset: -760;
				}
			}

			/* Dashed ring slow rotation — handled by SVG animateTransform to avoid CSS transform-origin drift */

			/* Cross pulsing beat */
			@keyframes beat {
				0%,
				100% {
					transform: scale(1);
					opacity: 0.9;
				}
				25% {
					transform: scale(1.12);
					opacity: 1;
				}
				60% {
					transform: scale(0.98);
					opacity: 0.85;
				}
			}
		</style>

		<!-- Soft ring glow background -->
		<circle
			cx="100"
			cy="100"
			r="88"
			fill="url(#ringGlow)" />

		<!-- Subtle dashed ring -->
		<g id="dashRing">
			<animateTransform
				attributeName="transform"
				type="rotate"
				from="0 100 100"
				to="360 100 100"
				dur="14s"
				repeatCount="indefinite" />
			<circle
				cx="100"
				cy="100"
				r="82"
				fill="none"
				stroke="#0ea5e9"
				stroke-opacity="0.25"
				stroke-width="6"
				stroke-linecap="round"
				stroke-dasharray="5 14" />
		</g>

		<!-- ECG path with flowing dash -->
		<path
			id="ecg"
			d="M20 105
           L50 105
           L60 95
           L66 125
           L74 80
           L80 120
           L105 105
           L113 95
           L120 110
           L135 105
           L180 105"
			fill="none"
			stroke="url(#ecgGrad)"
			stroke-width="4"
			stroke-linecap="round"
			filter="url(#softGlow)"
			stroke-dasharray="80 300"
			stroke-dashoffset="0"
			style="animation: ecgFlow 2.4s linear infinite" />

		<!-- Tiny progress dots (subtle, staggered) -->
		<g transform="translate(100,100)">
			<circle
				r="2.5"
				cx="70"
				cy="0"
				fill="#14b8a6">
				<animate
					attributeName="opacity"
					values="0.2;1;0.2"
					dur="1.8s"
					repeatCount="indefinite" />
			</circle>
			<circle
				r="2.5"
				cx="56"
				cy="40"
				fill="#0ea5e9">
				<animate
					attributeName="opacity"
					values="0.2;1;0.2"
					dur="1.8s"
					begin=".2s"
					repeatCount="indefinite" />
			</circle>
			<circle
				r="2.5"
				cx="20"
				cy="65"
				fill="#22c55e">
				<animate
					attributeName="opacity"
					values="0.2;1;0.2"
					dur="1.8s"
					begin=".4s"
					repeatCount="indefinite" />
			</circle>
		</g>
	</svg>
</div>
